module.exports = "https://static.energy5.com/_next/static/images/header-623ba7e0b977526aeedf191bacf51467.png";